import React, { useEffect } from "react";
import { connect } from "react-redux";
import { func } from "prop-types";

import { Box, Text } from "@ui-kit/components/index.es";
import { actions as layoutActions } from "reducers/layout";
import * as i18n from "util/i18n";

const HEADER_KEY = "recoveryPassword.step2.disclaimerV3.header";
const INTRO_KEY = "recoveryPassword.step2.disclaimerV3.intro";

function RecoveryInformationClaveTokenV3({ dispatch }) {
    useEffect(() => {
        dispatch(layoutActions.setScopes(["recoveryPassword"]));
        return () => {
            dispatch(layoutActions.setScopes([]));
        };
    }, [dispatch]);

    return (
        <Box flex column gap={24} w="100%" css={{ maxHeight: "50vh", minHeight: "50vh", overflowY: "auto" }}>
            <Text as="h2" variant="h3" color="white">
                {i18n.get(HEADER_KEY)}
            </Text>
            <Box column gap={20}>
                <Text variant="body" color="white" component="p">
                    {i18n.get(INTRO_KEY)}
                </Text>

                <Text variant="body" color="white" component="p">
                    {i18n.get("global.support.v3.whatsapp.label")} {i18n.get("global.support.v3.whatsapp.value")}
                </Text>

                <Text variant="body" color="white" component="p">
                    {i18n.get("global.support.v3.email.label")}{" "}
                    <a
                        href={i18n.get("global.support.v3.email.href")}
                        style={{ color: "inherit", textDecoration: "underline" }}>
                        {i18n.get("global.support.v3.email.value")}
                    </a>
                </Text>

                <Text variant="body" color="white" component="p">
                    {i18n.get("global.support.v3.phone.label")}{" "}
                    <a
                        href={i18n.get("global.support.v3.phone.href")}
                        style={{ color: "inherit", textDecoration: "underline" }}>
                        {i18n.get("global.support.v3.phone.value")}
                    </a>
                </Text>
            </Box>
        </Box>
    );
}

RecoveryInformationClaveTokenV3.propTypes = {
    dispatch: func.isRequired,
};

export default connect()(RecoveryInformationClaveTokenV3);
